import React from 'react';

import { LazyTrashedSpacesPage } from '@confluence/site-settings/entry-points/TrashedSpacesPage';
import { ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/trashedSpacesConstants';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminTrashedSpacesRoute = () => <LazyTrashedSpacesPage />;

AdminTrashedSpacesRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
